(() => {
  const KEY = { ENTER:13, ESC:27, SPACE:32, UP:38, DOWN:40, HOME:36, END:35 };

  function enhance(root) {
    if (!root || root.__lx) return;
    const native = root.querySelector('select[hidden][name^="options["]');
    const btn    = root.querySelector('.luxe-select__button');
    const label  = root.querySelector('.luxe-select__label');
    const panel  = root.querySelector('.luxe-select__panel');
    if (!native || !btn || !panel || !label) return;

    function setFromRow(row){
      if (!row) return;
      const val = row.getAttribute('data-value');
      if (val == null) return;
      native.value = val;
      native.dispatchEvent(new Event('change', { bubbles: true }));
      label.innerHTML = row.innerHTML;
      close();
      btn.focus();
    }

    function open(){
      panel.setAttribute('aria-hidden','false');
      btn.setAttribute('aria-expanded','true');
      (panel.querySelector('[aria-selected="true"]') || panel.firstElementChild)?.focus?.();
      document.addEventListener('click', onDoc);
      document.addEventListener('keydown', onKeys);
    }
    function close(){
      panel.setAttribute('aria-hidden','true');
      btn.setAttribute('aria-expanded','false');
      document.removeEventListener('click', onDoc);
      document.removeEventListener('keydown', onKeys);
    }
    function toggle(){ panel.getAttribute('aria-hidden')==='false' ? close() : open(); }
    function onDoc(e){ if (!root.contains(e.target)) close(); }
    function onKeys(e){
      if (panel.getAttribute('aria-hidden')==='true') return;
      const rows = Array.from(panel.querySelectorAll('.luxe-select__option'));
      const idx  = rows.indexOf(document.activeElement);
      const go = n => rows[Math.max(0,Math.min(rows.length-1,n))]?.focus();
      switch (e.keyCode){
        case KEY.ESC: e.preventDefault(); close(); btn.focus(); break;
        case KEY.UP: e.preventDefault(); go((idx===-1?0:idx-1)); break;
        case KEY.DOWN: e.preventDefault(); go((idx===-1?0:idx+1)); break;
        case KEY.HOME: e.preventDefault(); go(0); break;
        case KEY.END: e.preventDefault(); go(rows.length-1); break;
        case KEY.ENTER:
        case KEY.SPACE: e.preventDefault(); setFromRow(document.activeElement); break;
      }
    }

    btn.addEventListener('click', toggle);
    btn.addEventListener('keydown', e => {
      if ([KEY.SPACE, KEY.ENTER, KEY.DOWN].includes(e.keyCode)) { e.preventDefault(); open(); }
    });

    panel.querySelectorAll('.luxe-select__option').forEach(row => {
      row.addEventListener('click', () => setFromRow(row));
      row.addEventListener('keydown', e => {
        if (e.keyCode === KEY.ENTER || e.keyCode === KEY.SPACE) { e.preventDefault(); setFromRow(row); }
      });
    });

    native.addEventListener('change', () => {
      const val = native.value;
      let match = null;
      panel.querySelectorAll('.luxe-select__option').forEach(row => {
        const sel = row.getAttribute('data-value') === val;
        row.setAttribute('aria-selected', sel ? 'true' : 'false');
        if (sel) match = row;
      });
      if (match) label.innerHTML = match.innerHTML;
      else label.textContent = native.options[native.selectedIndex]?.textContent || 'Select';
    });

    root.__lx = true;
  }

  function init(scope=document){
    scope.querySelectorAll('[data-luxe-select]').forEach(enhance);
  }

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:select', e => init(e.target));
  document.addEventListener('variant:change', e => setTimeout(() => init(e.target?.closest('variant-selects')||document), 0));
  const obs = new MutationObserver(m => { if (m.some(x => x.addedNodes && x.addedNodes.length)) init(document); });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
